// extracted by mini-css-extract-plugin
export var contrastLow = "_h-1";
export var externalLink = "_h-2";
export var externalLinkIcon = "_h-3";
export var link = "_h-0";
export var linkLabel = "_h-4";